module.exports = __webpack_public_path__ + "static/media/bedford-logo-01BD62EB0F-seeklogo.com.263cb5b8.jpg";